// Perceptual tuning for the small toy-box simulation, not measured toy data.
const profiles={
  jelly:{restitution:.56,groundDrag:5,airDrag:.5},
  mochi:{restitution:.32,groundDrag:8,airDrag:.65},
  foam:{restitution:.02,groundDrag:13,airDrag:.8},
  slime:{restitution:0,groundDrag:22,airDrag:1.1},
  clay:{restitution:.01,groundDrag:18,airDrag:.9},
  beads:{restitution:.12,groundDrag:11,airDrag:.7},
  mesh:{restitution:.42,groundDrag:7,airDrag:.6},
  pouch:{restitution:.08,groundDrag:13,airDrag:.8},
  wax:{restitution:.06,groundDrag:10,airDrag:.7},
};
export const pileMaterialProfile=material=>profiles[material]??profiles.mochi;
